import { useAccountStore } from '~/stores/accountStore';
import { watch } from 'vue';

export default defineNuxtPlugin(() => {
    const accountStore = useAccountStore();

    const injectScript = (rawScript: string, target: 'head' | 'body') => {
        if (!rawScript) {
            return;
        }

        const temp = document.createElement('div');
        temp.innerHTML = rawScript;
        temp.querySelectorAll('script').forEach(original => {
            const script = document.createElement('script');
            for (const attr of original.attributes) {
                script.setAttribute(attr.name, attr.value);
            }
            if (!original.hasAttribute('src')) {
                script.text = original.textContent || '';
            }
            document[target].appendChild(script);
        });
    };

    watch(
        () => accountStore.state.headScript,
        (newHeadScript: string | null) => {
            if (newHeadScript) {
                injectScript(newHeadScript, 'head');
            }
        },
        { immediate: true }
    );

    watch(
        () => accountStore.state.bodyScript,
        (newBodyScript: string | null) => {
            if (newBodyScript) {
                injectScript(newBodyScript, 'body');
            }
        },
        { immediate: true }
    );
});
